import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash-es';
import { Option } from '../types';

@Pipe({ name: 'isActive' })
export class IsActivePipe implements PipeTransform {
  transform(option: Option, selectedOption: Option, displayKey: string = null): boolean {
    const optionValue = get(option, displayKey, null);
    const selectedOptionValue = get(selectedOption, displayKey, null);

    return (
      optionValue !== null && selectedOptionValue !== null && optionValue === selectedOptionValue
    );
  }
}
